import React from "react";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { PaginationButtons } from "../../common/components/PaginationButtons";
import { AxiosAreasAPI } from "../Api";
import { AreaTable } from "./AreaTable";
import { useQueryWithPagination } from "../../utils/Hooks";

export const AreaInactiveList = ({ search }) => {
  const { isPending, data, error, handlePrevious, handleNext } =
    useQueryWithPagination({
      queryKey: ["area-inactive-list", search],
      queryFn: AxiosAreasAPI.getAll,
      search: search,
      active: false,
    });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;
  if (data) {
    return (
      <>
        <AreaTable areas={data.results} active={false} />
        <PaginationButtons
          previous={data?.previous}
          next={data?.next}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      </>
    );
  }

  return null;
};
